import { createFileRoute, redirect } from '@tanstack/react-router'
import { AssetLifecyclePageContainer } from 'pages/assetLifecycleV2/AssetLifecyclePageContainer'
import {
  assetLifecycleDebugSearchSchema,
  assetLifecyclePageSearchSchema,
} from 'routes/assets/-searchParams'

const assetLifecycleV2SearchSchema = assetLifecyclePageSearchSchema.extend({
  debug: assetLifecycleDebugSearchSchema.optional(),
})

const RouteComponent = () => {
  const { unitId, orgId, ...rest } = Route.useSearch()

  if (!unitId || !orgId) return null

  return <AssetLifecyclePageContainer unitId={unitId} orgId={orgId} {...rest} />
}

/**
 * DO NOT ROUTE DIRECTLY TO HERE, INSTEAD GO THROUGH /assets/routing TO ENSURE YOU END UP AT THE CORRECT DESTINATION
 */
export const Route = createFileRoute(
  '/assets/(single_asset_destinations)/lifecycle'
)({
  validateSearch: assetLifecycleV2SearchSchema,
  beforeLoad: ({ search }) => {
    if (!search.unitId) {
      throw redirect({
        to: '/assets',
        search: { siteId: search.siteId },
      })
    }
  },
  staticData: {
    title: 'Asset Lifecycle V2',
    skipDefaultStyles: true,
  },
  component: RouteComponent,
})
